'use client';

import { LoaderCircleIcon } from 'lucide-react';

import { cn } from '@/lib/utils';
import { Button } from '../button';

type ButtonProps = React.ComponentProps<typeof Button>;

export function LoadingButton({
  isLoading,
  className,
  disabled,
  children,
  ...props
}: ButtonProps & { isLoading: boolean }) {
  return (
    <Button
      {...props}
      disabled={isLoading || disabled}
      data-loading={isLoading || undefined}
      className={cn('group relative', className)}
    >
      <span className="flex items-center justify-center gap-2 group-data-loading:opacity-0">{children}</span>{' '}
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center">
          <LoaderCircleIcon className="animate-spin" size={16} aria-hidden="true" />
        </div>
      )}
    </Button>
  );
}
